import { useMemo } from 'react';
import { useHoldings } from './useHoldings';
import { useRecoilValue } from 'recoil';
import { blockLimitedHoldingsSubjectsWithFees } from 'venn-state';
import { hasValidCoverage } from '../../blocks/custom-blocks/holdings-block/utils';
import { isNil } from 'lodash';

// Retrieves subjects categorized by fixed income coverage for a given holdings block ID
export function useFixedIncomeSubjects(id: string) {
  const allSubjects = useRecoilValue(blockLimitedHoldingsSubjectsWithFees(id));
  const { data } = useHoldings(id);

  return useMemo(() => {
    const subjectsWithFixedIncome: { name?: string; coverage: number }[] = [];
    const subjectsWithoutFixedIncome: { name?: string }[] = [];

    if (!data?.breakdowns) {
      return { subjectsWithFixedIncome, subjectsWithoutFixedIncome };
    }

    data.breakdowns.forEach((breakdown, i) => {
      const subject = allSubjects[i];
      if (isNil(subject)) return;

      if (hasValidCoverage(breakdown)) {
        subjectsWithFixedIncome.push({
          name: subject.name,
          coverage: breakdown.percentageCovered,
        });
      } else {
        subjectsWithoutFixedIncome.push({ name: subject.name });
      }
    });

    return { subjectsWithFixedIncome, subjectsWithoutFixedIncome };
  }, [allSubjects, data?.breakdowns]);
}
